var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Station 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Station-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#535455",
    strokeWidth: 2,
    points: "6 11.5 6 6.5 26 6.5 26 11.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,11.5 C3.96413845,10.8578559 4.96413845,10.5367839 6,10.5367839 C7.03586155,10.5367839 8.03586155,10.8578559 9,11.5 L9,24.5 C8,25.3921825 7,25.8382738 6,25.8382738 C5,25.8382738 4,25.3921825 3,24.5 L3,11.5 Z",
    id: "Rectangle",
    stroke: "#535455",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,11.5 C13.9641385,10.8578559 14.9641385,10.5367839 16,10.5367839 C17.0358615,10.5367839 18.0358615,10.8578559 19,11.5 L19,24.5 C18,25.3921825 17,25.8382738 16,25.8382738 C15,25.8382738 14,25.3921825 13,24.5 L13,11.5 Z",
    id: "Rectangle-Copy",
    stroke: "#535455",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,11.5 C23.9641385,10.8578559 24.9641385,10.5367839 26,10.5367839 C27.0358615,10.5367839 28.0358615,10.8578559 29,11.5 L29,24.5 C28,25.3921825 27,25.8382738 26,25.8382738 C25,25.8382738 24,25.3921825 23,24.5 L23,11.5 Z",
    id: "Rectangle-Copy-2",
    stroke: "#535455",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11.5,
    x2: 16,
    y2: 7,
    id: "Path-5",
    stroke: "#535455",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStation);
export default __webpack_public_path__ + "static/media/Station.ff4ed811.svg";
export { ForwardRef as ReactComponent };